import React from 'react';
import providerService from '../../services/providerService';
import LegacyClinicEquipment from './components/LegacyClinicEquipment';
import NewClinicEquipment from './components/NewClinicEquipment';
import { shouldUseNewClinicEquipment } from '../../utils/portalFeatures';

const ClinicEquipment = ({ rendering, country, lang }) => {
  const currentProvider = providerService.getCurrentProvider();

  return shouldUseNewClinicEquipment(currentProvider) ? (
    <NewClinicEquipment
      rendering={rendering}
      country={country}
      lang={lang}
    />
  ) : (
    <LegacyClinicEquipment />
  );
};

export default ClinicEquipment;
